import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const purchaseOrderFreightCreateAtom = createMutationAtomFactory(
  'trade.purchaseOrderFreightCreate',
  (params: {
    purchaseOrderId: string;
    carrierId?: string | null;
    freightLaneId?: string | null;
    rateFormula?: string | null;
    rateVariableIds?: string | null;
    chargebackFormula?: string | null;
    chargebackVariableIds?: string | null;
    fuelSurchargeFormula?: string | null;
    fuelSurchargeVariableIds?: string | null;
    fuelSurchargeMode?: string | null;
    notes?: string | null;
  }) => ({
    tradePurchaseOrderFreightCreate: {
      __args: {
        input: {
          purchaseOrderId: params.purchaseOrderId,
          carrierId: params.carrierId,
          freightLaneId: params.freightLaneId,
          rateFormula: params.rateFormula,
          rateVariableIds: params.rateVariableIds,
          chargebackFormula: params.chargebackFormula,
          chargebackVariableIds: params.chargebackVariableIds,
          fuelSurchargeFormula: params.fuelSurchargeFormula,
          fuelSurchargeVariableIds: params.fuelSurchargeVariableIds,
          fuelSurchargeMode: params.fuelSurchargeMode,
          notes: params.notes,
        },
      },
      id: true,
      purchaseOrderId: true,
      carrierId: true,
      freightLaneId: true,
      rateFormula: true,
      chargebackFormula: true,
      fuelSurchargeFormula: true,
      fuelSurchargeMode: true,
      notes: true,
      timestamps: {
        createdAt: true,
        updatedAt: true,
      },
    },
  }),
);

export const purchaseOrderFreightUpdateAtom = createMutationAtomFactory(
  'trade.purchaseOrderFreightUpdate',
  (params: {
    id: string;
    carrierId?: string | null;
    freightLaneId?: string | null;
    rateFormula?: string | null;
    rateVariableIds?: string | null;
    chargebackFormula?: string | null;
    chargebackVariableIds?: string | null;
    fuelSurchargeFormula?: string | null;
    fuelSurchargeVariableIds?: string | null;
    fuelSurchargeMode?: string | null;
    notes?: string | null;
  }) => ({
    tradePurchaseOrderFreightUpdate: {
      __args: {
        id: params.id,
        input: {
          carrierId: params.carrierId,
          freightLaneId: params.freightLaneId,
          rateFormula: params.rateFormula,
          rateVariableIds: params.rateVariableIds,
          chargebackFormula: params.chargebackFormula,
          chargebackVariableIds: params.chargebackVariableIds,
          fuelSurchargeFormula: params.fuelSurchargeFormula,
          fuelSurchargeVariableIds: params.fuelSurchargeVariableIds,
          fuelSurchargeMode: params.fuelSurchargeMode,
          notes: params.notes,
        },
      },
      id: true,
      purchaseOrderId: true,
      carrierId: true,
      freightLaneId: true,
      rateFormula: true,
      chargebackFormula: true,
      fuelSurchargeFormula: true,
      fuelSurchargeMode: true,
      notes: true,
      timestamps: {
        createdAt: true,
        updatedAt: true,
      },
    },
  }),
);

export const purchaseOrderFreightDeleteAtom = createMutationAtomFactory(
  'trade.purchaseOrderFreightDelete',
  (params: { id: string }) => ({
    tradePurchaseOrderFreightDelete: {
      __args: {
        id: params.id,
      },
    },
  }),
);
